import React, { Fragment, Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators, compose } from "redux"
import { withRouter } from "react-router-dom"
import { isEmpty } from "lodash"

import history from "app/history"
import InputField from "components/input"
import SubmitNotification from "components/common/submit-notification"

import { resetPassword, showAuthModal } from "store/auth/action"

import { validateNumber } from "helpers/regex-validator"

import { AUTH_TYPES, AUTH_SUCCESS } from "constants/auth-types"
import { GOOGLE_SITE_KEY } from "constants/config"

import SendIcon from "assets/icons/send.svg"

// Import Styles
import "styles/components/auth/auth.scss"

export class ResetPassword extends Component {
  constructor() {
    super()

    this.state = {
      resetForm: {
        password: "",
        password_confirm: "",
      },
      fieldErrors: {},
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      auth: { errors },
    } = this.props

    const {
      auth: { errors: prevErrors },
    } = prevProps

    if (errors !== prevErrors) {
      this.setState({ fieldErrors: errors })
    }
  }

  handleChange = (e) => {
    const { resetForm } = this.state
    const { name, value } = e.currentTarget
    this.setState(
      {
        resetForm: {
          ...resetForm,
          [name]: value,
        },
      },
      () => {
        this.validateField(name)
      }
    )
  }

  validateField = (fieldName) => {
    let fieldErrors = this.state.fieldErrors

    //add more validations
    if (isEmpty(fieldErrors[fieldName])) {
      fieldErrors.fieldName = "This field is required"
    } else {
      delete fieldErrors[fieldName]
    }
    this.setState({ fieldErrors })
  }

  handleResetPassword = (e) => {
    e.preventDefault()

    const {
      location: { pathname },
      resetPassword,
    } = this.props
    const { resetForm } = this.state

    let currentPath = pathname.split("/")
    let resetToken = ""
    if (currentPath[1] === "reset_password") {
      resetToken = currentPath[2]
    }
    const { error } = this.validateOnSubmit(resetForm)

    if (!isEmpty(error)) {
      this.setState({ fieldErrors: error })
    } else {
      window.grecaptcha.ready(() => {
        window.grecaptcha
          .execute(GOOGLE_SITE_KEY, { action: "submit" })
          .then((token) => {
            resetForm["uid_and_token_b64"] = resetToken
            resetForm["g-recaptcha-response"] = token
            resetPassword(resetForm)
          })
      })
    }
  }

  validateOnSubmit(values) {
    const error = {}

    if (!values.password) {
      error.password = "Password is required"
    } else if (values.password.length < 8) {
      error.password = "Password must contain atleast 8 characters."
    } else if (validateNumber(values.password)) {
      error.password = "Password must contain letters and numbers."
    }

    if (!values.password_confirm) {
      error.password_confirm = "Password is required"
    }

    if (
      values.password &&
      values.password_confirm &&
      values.password !== values.password_confirm
    ) {
      error.password_confirm = "Password not match."
    }

    return { error }
  }

  handleGoToLogin() {
    const { showAuthModal } = this.props

    history.push("/")
    showAuthModal({ type: AUTH_TYPES.LOGIN })
  }

  render() {
    const { resetForm, fieldErrors } = this.state

    const {
      auth: { isLoading, authModal, errors },
    } = this.props

    return (
      <div className="rows is-full-container">
        {authModal.successType === AUTH_SUCCESS.RESET_PASSWORD ? (
          <Fragment>
            <div className="row upper-container">
              <figure className="image">
                <img src={SendIcon} alt="send" className="send-icon" />
              </figure>
              <h3 className="font-xl colored mb-xl">You're almost there!</h3>
              <h3 className="font-l mb-s">
                Try logging in using your new password
              </h3>
            </div>
            <div className="row bottom-container">
              <label
                className="font-m is-hover"
                onClick={() => this.handleGoToLogin()}
              >
                Go back to
                <span className="footer-text">Login</span>
              </label>
            </div>
          </Fragment>
        ) : (
          <Fragment>
            <form
              className="row upper-container"
              onSubmit={this.handleResetPassword}
            >
              <h3 className="font-xl colored mb-s is-capitalized">
                Reset Password
              </h3>
              <h3 className="font-m mb-xl">
                Think of a secured password that you won't forget
              </h3>
              <SubmitNotification
                type={errors && errors.uid_and_token_b64 && "FAILED"}
                message={errors && errors.uid_and_token_b64}
              />
              <div className="control">
                <InputField
                  label="New Password"
                  name="password"
                  required={true}
                  type="password"
                  value={resetForm["password"]}
                  error={fieldErrors["password"]}
                  onChange={this.handleChange}
                />
              </div>
              <div className="control">
                <InputField
                  label="Confirm Password"
                  name="password_confirm"
                  required={true}
                  type="password"
                  value={resetForm["password_confirm"]}
                  error={fieldErrors["password_confirm"]}
                  onChange={this.handleChange}
                />
              </div>
              <button
                className={`app-button is-secondary mb-m is-uppercase is-fullwidth ${
                  isLoading ? "is-loading" : ""
                }`}
              >
                Send
              </button>
            </form>
            <div className="row bottom-container">
              <label
                className="font-m is-hover"
                onClick={() => this.handleGoToLogin()}
              >
                Go back to
                <span className="footer-text">Login</span>
              </label>
            </div>
          </Fragment>
        )}
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  auth: state.authReducer,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      resetPassword,
      showAuthModal,
    },
    dispatch
  )

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter
)(ResetPassword)
